import { Injectable, ApplicationRef, NgZone } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ChangeDetectionInterceptor implements HttpInterceptor {

  constructor(private appRef: ApplicationRef, private ngZone: NgZone) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          // Wait for component subscribe callbacks to process the data,
          // then force change detection inside Angular zone
          this.ngZone.run(() => {
            setTimeout(() => {
              this.appRef.tick();
            }, 0);
          });
        }
      })
    );
  }
}
